import { buildAggregateDataReporter } from './buildAggregateDataReporter';
export const buildTrackerCallbacks = () => {
  const reporter = buildAggregateDataReporter();
  reporter.start();
  return {
    onError(error) {
      reporter.captureEvent(`[error] ${error}`);
    }
  };
};